export default __webpack_public_path__ + "static/media/682.e37bda71.png";